import { inertAllBut } from "../popover";

jQuery(document).ready(function($){
	$(document.body).on('wc_fragments_loaded', updateCrateDetails );
} );

async function updateCrateDetails() {
	const shipping_elems = document.querySelectorAll('.shipping-cost');
	if ( ! shipping_elems?.length ) return;

	for( const shipping_elem of shipping_elems ) {
		const results = await window.wp.apiFetch({path:"/birnn/v1/crate-packing-details"});

		const total_crates = shipping_elem.querySelector('.data_total-crates');
		const message = shipping_elem.querySelector( '.data_message' )
		const fullness_percent = shipping_elem.querySelector( '.data_fullness-percent' );
		const progress = shipping_elem.querySelector( '.shipping-cost_progress' );

		if ( total_crates && Object.hasOwn(results, 'total_crates') ) {
			total_crates.textContent = results?.total_crates ?? '0'
		}
		if ( fullness_percent && Object.hasOwn(results, 'fullness_percent') ) {
			fullness_percent.textContent = results?.fullness_percent ?? '0'
		}
		if ( progress && Object.hasOwn(results, 'slots_used_in_last_crate') ) {
			progress.value = results?.slots_used_in_last_crate
		}
		if ( progress && Object.hasOwn(results, 'total_slots_available') ) {
			progress.max = results?.total_slots_available
		}
		if ( message && Object.hasOwn(results, 'message') ) {
			message.textContent = results?.message
		}
	}
}

jQuery(document).ready(function($){
	const { computePosition, autoPlacement, shift, offset, size } = window.FloatingUIDOM;
	const popovers = document.querySelectorAll('.shipping-cost_info-popover');
	let reset = null;
	for ( const popover of popovers ) {
		if ( ! popover ) continue
		popover.addEventListener("toggle", (event) => {
			if(event.newState === "open") {
				popover.classList.add( '--open' );
				reset = inertAllBut(popover)
			} else {
				popover.classList.remove( '--open' );
				reset?.()
			}
			computePosition(product_card, popover, {
				placement: 'left',
				middleware: [
					autoPlacement(),
					shift({padding: 5}),
					offset(5),
					size({
						apply({availableWidth, availableHeight, elements}) {
							Object.assign(elements.floating.style, {
								maxWidth: `min(${Math.max(0, availableWidth - 20)}px, 90vw)`,
							});
						},
					}),
				],
			}).then( ( {x,y} ) => {
				Object.assign(
					popover.style, {
						left: `${x}px`,
						top: `${y}px`,
					}
				)
				popover.querySelector('button').focus({preventScroll: true, focusVisisble: true})
			} );
		} );
	}
} );